// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../shared/action-creators/busy-counter';
import actions from '../actions-list';
import {getNotifications} from '../shared/repositories';

export const readNotifications = () =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const allNotifications = await getNotifications();

            dispatch({
                data: allNotifications,
                type: actions.GET_NOTIFICATIONS
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/home-page/action-creators/notifications.js